import React, { FC, useMemo } from 'react';

import { useFormikContext } from 'formik';

import SearchableSelect, {
    SearchableSelectType,
} from '../../../../../../components/inputs/searchableSelect';
import AampeItalicText from '../../../../../../components/shared/AampeText/AampeItalicText';
import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';
import { iosButtonFields, IosCategoryIdentifierOptions } from './constants';

import { NotificationButtonFormValues } from '../../../../../../models/formula.model';
import { IosCategoryIdentifier } from '../../../../../../models/notificationButton.model';

import FieldToggle from './FieldToggle';
import IosButtonFields from './IosButtonFields';

const IosButtonForm: FC = () => {
    const { setFieldValue, values } =
        useFormikContext<NotificationButtonFormValues>();

    const { iosToggle, iosNotificationCategory } = values;

    const selectValue = useMemo<SearchableSelectType | undefined>(
        () =>
            iosToggle
                ? IosCategoryIdentifierOptions.find(
                      (item) => item.value === iosNotificationCategory,
                  )
                : { label: 'Select your iOs notification category', value: '' },
        [iosNotificationCategory, iosToggle],
    );

    return (
        <Container>
            <FieldToggle
                isActive={iosToggle}
                platform="iOS"
                fieldKey="iosToggle"
                setFieldValue={setFieldValue}
            />

            <SelectFieldContainer>
                <Title>
                    iOS notification category{' '}
                    <AampeItalicText text={'(Required)'} />
                </Title>
                <SearchableSelect
                    name="iosNotificationCategory"
                    options={IosCategoryIdentifierOptions}
                    value={selectValue}
                    onChange={(field, value) => {
                        setFieldValue(field, (value as any).value);
                        const fields =
                            iosButtonFields?.[
                                ((value as any).value ||
                                    selectValue?.value) as IosCategoryIdentifier
                            ] || [];

                        setFieldValue('iosButtons', fields);
                    }}
                    placeholder={'Select your iOs notification category'}
                    isDisabled={!values.iosToggle}
                />
            </SelectFieldContainer>

            {iosNotificationCategory && <Title isBold>Button behavior </Title>}
            <IosButtonFields />
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(6),
    minHeight: '300px',
});

const SelectFieldContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(2),
});

const Title = styled.div<{ isBold?: boolean }>(({ isBold }) => ({
    fontSize: aampeTheme.size.font.default,
    fontWeight: isBold ? aampeTheme.weights.medium : aampeTheme.weights.light,
    lineHeight: aampeTheme.size.lineHeight.small,
    color: aampeTheme.colors.neutral09,
}));

export default IosButtonForm;
